import React, { useState, useEffect, useRef, useCallback } from 'react'; // eslint-disable-line
import general from '../../../../../../general';
import './css/DateSearch.css';

const WEEK_DAYS = ['日', '一', '二', '三', '四', '五', '六'];

function getDaysInMonth(year, month) {
  return new Date(year, month + 1, 0).getDate();
}

/** 生成从 createDay 所在月到当月的月份数组 */
function buildMonths(createDay) {
  const today = new Date();
  const startYear  = createDay ? createDay.getFullYear() : today.getFullYear();
  const startMonth = createDay ? createDay.getMonth()    : today.getMonth();
  const result = [];
  let year = startYear;
  let month = startMonth;
  while (year < today.getFullYear() || (year === today.getFullYear() && month <= today.getMonth())) {
    const firstDay = new Date(year, month, 1).getDay();
    const total    = getDaysInMonth(year, month);
    const cells    = [];
    for (let p = 0; p < firstDay; p++) cells.push(null);
    for (let d = 1; d <= total; d++) cells.push(d);
    result.push({ year, month, cells });
    month++;
    if (month > 11) { month = 0; year++; }
  }
  return result;
}

export default function DateSearch(props) {
  const { tid, createTime: createTimeStr } = props.query;
  const today = new Date();
  today.setHours(23, 59, 59, 999);

  // 群创建日期（精确到天）
  const createDay = createTimeStr && parseInt(createTimeStr) > 0
    ? (() => { const d = new Date(parseInt(createTimeStr)); return new Date(d.getFullYear(), d.getMonth(), d.getDate()); })()
    : null;

  const scrollAreaRef = useRef(null);
  const hasInitedRef  = useRef(false);
  const [visible, setVisible] = useState(false);

  const months = buildMonths(createDay);

  // 仅首次激活时：先隐藏 → 滚到底部（当月）→ 再显示，避免初始闪烁
  useEffect(() => {
    if (!props.active) return;
    if (hasInitedRef.current) return;
    hasInitedRef.current = true;
    setVisible(false);
    requestAnimationFrame(() => requestAnimationFrame(() => {
      const el = scrollAreaRef.current;
      if (el) el.scrollTop = el.scrollHeight;
      setVisible(true);
    }));
  // eslint-disable-next-line
  }, [props.active]);

  const handleDayClick = useCallback((e, year, month, day) => {
    if (!day) return;
    const clicked = new Date(year, month, day);
    if (clicked > today) return;
    if (createDay && clicked < createDay) return;
    const dateStr = `${year}-${String(month + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
    const beginTime = new Date(`${dateStr} 00:00:00`).getTime();
    general.history.push(`/chatHistoryViewer?tid=${tid}&time=${beginTime}`);
  // eslint-disable-next-line
  }, [tid, createDay]);

  const isToday = (year, month, day) => {
    const now = new Date();
    return day === now.getDate() && month === now.getMonth() && year === now.getFullYear();
  };

  const isFuture = (year, month, day) =>
    day != null && new Date(year, month, day) > today;

  const isBeforeCreate = (year, month, day) =>
    day != null && createDay != null && new Date(year, month, day) < createDay;

  return (
    <div className="ds-wrapper">
      <div className="ds-week-header">
        {WEEK_DAYS.map(d => <div key={d} className="ds-week-cell">{d}</div>)}
      </div>

      <div className="ds-scroll-area" ref={scrollAreaRef} style={{ opacity: visible ? 1 : 0 }}>
        {months.map(({ year, month, cells }) => (
          <div key={`${year}-${month}`} className="ds-month-block">
            <div className="ds-month-label">{year}年{month + 1}月</div>
            <div className="ds-day-grid">
              {cells.map((day, idx) => (
                <div
                  key={idx}
                  className={[
                    'ds-day-cell',
                    !day                             ? 'ds-day-empty'         : '',
                    isFuture(year, month, day)       ? 'ds-day-future'        : '',
                    isBeforeCreate(year, month, day) ? 'ds-day-before-create' : '',
                    isToday(year, month, day)        ? 'ds-day-today'         : '',
                  ].filter(Boolean).join(' ')}
                  onClick={(e) => handleDayClick(e, year, month, day)}
                >
                  <span className="ds-day-inner">{day || ''}</span>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
